import React from "react";
import MenuIcon from '@mui/icons-material/Menu';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, IconButton, List, ListItem, ListItemButton, ListItemText, Menu, MenuItem, TextField, Tooltip } from "@mui/material";
import { useProfile } from "../../../common/useProfile";
import { Backup, Delete } from "@mui/icons-material";
import Service from "../../../../util/Service";


export default function MenuBackupPage(props) {
    const { pagina, action, placement } = props;

    const [anchorEl, setAnchorEl] = React.useState(null);
    const [openDialog, setOpenDialog] = React.useState(false);
    const [wait, setWait] = React.useState(true);
    const [backups, setBackups] = React.useState(false);

    const open = Boolean(anchorEl);

    React.useEffect(() => {
        if (open) {
            Service.GET('/api/security/paginaHtml/buscaBackup/' + pagina.id).then(r => {
                setBackups(r);
                setWait(false);
            })
        }
    }, [open])

    const handleCloseDialog = () => {
        setOpenDialog(false);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    function handleAbrirBackup(event) {
        setAnchorEl(event.currentTarget);
    }
    function handleNovoBackup() {
        setOpenDialog(true);
        handleClose();
    }
    function formataData(time) {
        if (!time) return '';
        const dt = new Date(time);
        return dt.toLocaleDateString() + " " + dt.toLocaleTimeString();
    }
    const handleSubmit = (event) => {
        event.preventDefault();
        const formData = new FormData(event.currentTarget);
        const formJson = Object.fromEntries(formData.entries());
        const nome = formJson.nome;

        const dado = {
            nome: nome,
            idPagina: pagina.id
        }

        Service.POST("/api/security/paginaHtml/backup", dado).then(r => {
            if (!r.success) {
                alert(r.msg)
            } else {
                handleClose();
                handleCloseDialog();
            }
        })
    };
    function handleGetBackup(item){
        Service.GET('/api/security/paginaHtml/voltarBackup/' + item.id).then(r => {
                if( action )action(r);
                handleClose();
                handleCloseDialog();
            })
    }

    return (
        <React.Fragment>
            <Tooltip title="Backup da pagina" placement={placement}>
                <IconButton
                    size="large"
                    color="inherit"
                    // onClick={() => setTrigger(!trigger)} sx={{ p: 0 }}
                    onClick={handleAbrirBackup}
                >
                    <Backup />
                </IconButton>
            </Tooltip>

            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                slotProps={{
                    list: {
                        'aria-labelledby': 'basic-button',
                    },
                }}
            >
                <List sx={{
                    maxWidth: 460, bgcolor: 'background.paper',
                    overflow: 'auto',
                    maxHeight: 300,
                }}
                >
                    {wait && <ListItem>
                        <ListItemText primary="Aguarde...." />
                    </ListItem>}
                    {backups && backups.map((row, id) =>
                        <ListItem key={id}
                            secondaryAction={
                                <IconButton edge="end" aria-label="delete" onClick={() =>alert('não implementado.....')}>
                                    <Delete />
                                </IconButton>
                            }
                            sx={{cursor:'pointer'}}
                            onClick={() =>handleGetBackup(row)}
                        >
                            {/* <ListItemButton> */}
                                <ListItemText primary={row.nome} secondary={formataData(row.dtCriacao)} />
                            {/* </ListItemButton> */}
                        </ListItem>
                    )}                   
                </List>

                <Divider />
                <MenuItem onClick={handleNovoBackup}>Novo Backup</MenuItem>
            </Menu>

            <Dialog open={openDialog} onClose={handleCloseDialog}>
                <DialogTitle>Backup</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Indique um nome para posterior recuperação, por exemplo um nome fix, melhoria, nova implementação, etc.
                    </DialogContentText>
                    <form onSubmit={handleSubmit} id="subscription-form">
                        <TextField
                            autoFocus
                            required
                            margin="dense"
                            // id="name"
                            name="nome"
                            label="Nome do Backup"
                            fullWidth
                            variant="standard"
                        />
                    </form>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDialog}>Cancel</Button>
                    <Button type="submit" form="subscription-form">
                        Criar backup
                    </Button>
                </DialogActions>
            </Dialog>

        </React.Fragment>
    )
}